import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  DeleteCompanyWarehouseActions as Actions,
  DeleteCompanyWarehouseRequestAction as RequestAction,
} from 'store/ducks/companyWarehouses';

export function* deleteCompanyWarehouseRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.delete, `company-warehouses/${id}`);
    onSuccess && onSuccess();
    notify('success', 'Armazém desvinculado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
